


























import Vue from "vue";
import { Trophy } from "@tt-app/models";
import { AudioData } from "@tt-app/types";
import { AudioDecoderPlayer } from "@tt-app/utils";

import ExerciseTrophy from "@tt-app/components/exercise/common/ExerciseTrophy.vue";
import ImageCard from "@tt-app/components/exercise/common/ImageCard.vue";
import ListeningMultipleChoice from "@tt-app/components/quiz/ListeningMultipleChoice.vue";
import ListeningReviewCard from "@tt-app/components/quiz/ListeningReviewCard.vue";

interface Methods {
  component: (componentConfig: { type: string }) => string;
}

interface Computed {
  reviewElements: any[];
}

interface Props {
  audioData: AudioData;
  audioDecoderPlayer: AudioDecoderPlayer;
  answers: any;
  review: {
    body: any[];
  };
  selectedOptions: any;
  allProblemUuids: string[];
  trophy?: Trophy;
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: "ListeningReview",
  components: {
    ExerciseTrophy,
    ImageCard,
    ListeningMultipleChoice,
    ListeningReviewCard
  },
  props: {
    answers: {
      type: Object,
      required: true
    },
    audioData: {
      type: Object,
      default: (): AudioData => ({})
    },
    audioDecoderPlayer: {
      type: AudioDecoderPlayer,
      default: undefined
    },
    review: {
      type: Object,
      required: true
    },
    selectedOptions: {
      type: Object,
      required: true
    },
    allProblemUuids: {
      type: Array,
      required: true
    },
    trophy: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    reviewElements() {
      if (!this.review.body) {
        return [];
      }

      return this.review.body;
    }
  },
  methods: {
    component(componentConfig) {
      const components: { [key: string]: string } = {
        CARD: "listening-review-card",
        IMAGE: "image-card",
        TEXT_SINGLE_SELECTION: "listening-multiple-choice"
      };

      const { type } = componentConfig;

      return components[type];
    }
  }
});
